exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".approval-needed-users[data-v-978c814c]{background-color:#fff;padding:10px}.custom-table[data-v-978c814c]{width:100%}.custom-table td[data-v-978c814c],.custom-table th[data-v-978c814c]{border-bottom:1px solid #ddd;padding:10px}.table-title[data-v-978c814c]{font-size:16px;font-weight:700;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-978c814c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Programs/Card-list/ApprovalNeededUsers.vue
// module id = XVFF
// module chunks = 12